module.exports = __webpack_public_path__ + "img/icon_star.6d9d2c76.svg";